import Autosuggest, { AutosuggestProps } from 'components/atoms/inputs/Autosuggest'
import { WrappedFieldInputProps, WrappedFieldProps } from 'redux-form'
import { State } from 'interfaces/state'
import { prepareFieldErrors } from 'helpers/formHelpers'

type ReusedAutosuggestProp =
  | 'options'
  | 'isLoading'
  | 'disabled'
  | 'onRequestSuggestions'
  | 'label'
  | 'placeholder'
  | 'theme'
  | 'requestOptimization'
  | 'lastSentQuery'
  | 'autoComplete'
  | 'autoFocus'
  | 'qaMarker'
  | 'qaType'
  | 'contentRenderer'
  | 'showIcon'
  | 'shouldPlaceSelectedToInput'
  | 'isAlwaysBelowInput'
  | 'showLabelAsLink'
  | 'rounded'

export type AutosuggestWrappedOwnProps<TValue = number> = Pick<AutosuggestProps<TValue>, ReusedAutosuggestProp>

export type AutosuggestWrappedProps<TValue = number> = WrappedFieldProps<State> & AutosuggestWrappedOwnProps<TValue>

const normalizeValue = (value: any) =>
  value === '' ? null : value

/**
 * AutosuggestWrapped is a wrapper of Autosuggest for compatibility with redux-form
 */
function AutosuggestWrapped<TValue = number> (props: AutosuggestWrappedProps<TValue>) {
  const {
    meta,
    ...restProps
  } = props
  const input = props.input as WrappedFieldInputProps
  const { active, touched, error } = meta

  const value = normalizeValue(input.value)
  // we should pass value through onBlur
  // because redux-form ("is a douchebag" - strikethrough)
  // requires it for starting async validation
  const handleBlur = () => input.onBlur(value)

  const TypedAutosuggest: new () => Autosuggest<TValue> = Autosuggest as any

  return (
    <TypedAutosuggest
      onFocus={ input.onFocus as any }
      onChange={ input.onChange as any }
      onBlur={ handleBlur }
      selected={ value }
      active={ Boolean(active) }
      errors={ prepareFieldErrors(error, touched) }
      errored={ touched && !!error }
      touched={ touched }
      meta={ meta }
      { ...restProps }
    />
  )
}

export default AutosuggestWrapped
